import { ExclamationCircleIcon, TrashIcon } from "@heroicons/react/24/outline";
import { useEffect, useState } from "react";
import { useDeleteBlueprintAssign } from "../../api/BlueprintsApi";
import Button, { ButtonColorTypes } from "../../shared-components/Button";
import ErrorMessageContainer from "../../shared-components/ErrorMessageContainer";
import { Modal } from "../../shared-components/Modal";
import { useVerifyBlueprintDelete } from "../../api/CompaniesApi";

type Props = {
  companyUUID: string;
  blueprintUUID: string;
  onRemove: (blueprintUUID: string) => void;
};

const CompanyBlueprintRemove = ({
  blueprintUUID,
  companyUUID,
  onRemove,
}: Props) => {
  const [showModal, setShowModal] = useState(false);
  const {
    mutate: deleteBlueprint,
    isError: errorDeleteBlueprint,
    isSuccess: isSucessDelete,
  } = useDeleteBlueprintAssign();
  const {
    mutate: verify,
    data: verifyData,
    isError: verifyError,
    isLoading: verifyLoading,
  } = useVerifyBlueprintDelete();

  useEffect(() => {
    if (isSucessDelete) {
      handleClose();
      onRemove(blueprintUUID);
    }
  }, [blueprintUUID, isSucessDelete, onRemove]);

  function handleClose() {
    setShowModal(false);
  }

  function handleRemove() {
    deleteBlueprint({
      blueprint_uuid: blueprintUUID,
      company_uuid: companyUUID,
    });
  }
  return (
    <div>
      <TrashIcon
        className="w-4 cursor-pointer"
        onClick={() => {
          if (verifyData === undefined || verifyError) {
            verify({ blueprintUUID: blueprintUUID, companyUUID: companyUUID });
          }
          setShowModal(true);
        }}
      />
      <Modal open={showModal} onClose={handleClose} width={"w-104 p-3"}>
        <div>
          <div className="flex gap-4 mb-4">
            <div className="flex justify-center w-9 h-9 rounded-full bg-red-100">
              <ExclamationCircleIcon className="w-6 text-red-500" />
            </div>
            {(verifyData && verifyData.length > 0) || verifyError ? (
              <div className="flex flex-col">
                <span className="text-sm text-gray-400">
                  This Checktype cannot be removed because it is being used in
                  an active recurring check subscription(s).
                </span>
                <span className="text-sm text-gray-400">
                  Please cancel any active subscription and try again.
                </span>
              </div>
            ) : (
              <div className="flex flex-col">
                <span className="text-lg font-bold mb-2">
                  Remove Check Type?
                </span>
                <span className="text-sm text-gray-400">
                  Removing check type will detach check type from this company.
                </span>
              </div>
            )}
          </div>
          {errorDeleteBlueprint && (
            <ErrorMessageContainer message="Couldn't delete check type" />
          )}
          <div className="flex gap-4 justify-end">
            <Button
              text={"Cancel"}
              colorType={ButtonColorTypes.cancel}
              onClick={handleClose}
            />
            <Button
              text="Ok"
              colorType={ButtonColorTypes.secondary}
              onClick={handleRemove}
              disabled={
                verifyLoading || (verifyData?.length ?? 1) > 0 || verifyError
              }
            />
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default CompanyBlueprintRemove;
